"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateSearch = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../classes/com/tmpls");
const StatePaged_1 = require("../../classes/states/abstracts/StatePaged");
const App_1 = require("../../classes/App");
const models_1 = require("../../classes/api/classes/models");
const CmpProductTile_1 = require("../../classes/com/CmpProductTile");
const BreadCrumb_1 = require("../../classes/models/BreadCrumb");
const ClassesTags_1 = require("../../classes/ClassesTags");
const SearchController_1 = require("../../classes/appControllers/SearchController");
const AppPM_1 = require("../AppPM");
class StateSearch extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageProducts, "Профимолл", true);
        this._productIds = [];
        this._skip = 0;
        this._query = "";
        this.page.ctrls.cmpPagination.ctrls.btnNext.onclick = () => this._loadNextAsync();
        this._refreshQuery = (e) => this.search();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const categories = yield App_1.App.Inst.cache.getCategoriesAsync();
            if (!categories)
                return gs.StateRunResultEnum.Skipped; //TODO сделать что-то если не загрузятся
            if (args && args.query)
                this._query = decodeURIComponent(args.query);
            yield this.page.ctrls.cmpFilterLine.fillAsync();
            yield this.search();
            if (this._query)
                this._searchAsync();
            return _super.start.call(this);
        });
    }
    afterStart(args) {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this, args);
            this.app.getInst(SearchController_1.SearchController).onRefreshQuery.addHandler(this._refreshQuery);
            AppPM_1.AppPM.GUI.setSearchQuery(this._query);
        });
    }
    stop() {
        const _super = Object.create(null, {
            stop: { get: () => super.stop }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.app.getInst(SearchController_1.SearchController).onRefreshQuery.removeHandler(this._refreshQuery);
            yield _super.stop.call(this);
        });
    }
    search(query = '') {
        return __awaiter(this, void 0, void 0, function* () {
            if (query)
                this._query = decodeURIComponent(query);
            this.page.ctrls.lHeader.text = "Результаты поиска";
            let crumbs = [];
            crumbs.unshift(new BreadCrumb_1.BreadCrumb("Поиск", "/search?query=" + encodeURIComponent(this._query)));
            crumbs.unshift(new BreadCrumb_1.BreadCrumb("Главная", "/"));
            AppPM_1.AppPM.GUI.setBreadcrumbs(crumbs);
            let filterStr = this.app.getInst(SearchController_1.SearchController).getFilterString();
            this._urlArgs["path0"] = StateSearch.StateName;
            this._urlArgs["query"] = this._query;
            if (filterStr)
                this._urlArgs["filter"] = filterStr;
            else
                delete this._urlArgs["filter"];
            this.updateUrl();
            if (this._query)
                this._searchAsync();
        });
    }
    _searchAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.cmpFilterLine.setInSearch();
            this.page.ctrls.cmpPagination.hide();
            this._addListPlaceholders();
            const searchCtrl = this.app.getInst(SearchController_1.SearchController);
            const filters = searchCtrl.getFilters();
            const data = new models_1.SearchService_SearchProductsIds_Request();
            data.query = this._query;
            data.filters = filters;
            data.sortType = searchCtrl.sortType;
            let prodIds = yield this.app.api.searchService.searchProductsIds(data);
            //let prodIds = await App.Inst.gui.lockAction(App.Inst.api.searchService.searchProductsIds(data));
            if (!prodIds) {
                this._failedLoadAsync();
                return;
            }
            this._productIds = prodIds;
            this.page.ctrls.cmpFilterLine.setSearchResult(this._productIds.length);
            this.page.ctrls.lHeader.text = `Результаты поиска (${this._productIds.length})`;
            this._skip = 0;
            this._loadNextAsync(true);
        });
    }
    _loadNextAsync(withClearList = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let takeIds = this._productIds.slice(this._skip, this._skip + StatePaged_1.StatePaged.TakeProductsCount);
            this.page.ctrls.cmpPagination.disable();
            let products = yield this.app.cache.getProductsAsync(takeIds);
            this.page.ctrls.cmpPagination.enable();
            if (withClearList)
                this.page.ctrls.listProducts.html = '';
            if (!products) {
                return;
            }
            for (const prod of products) {
                let item = new CmpProductTile_1.CmpProductTile();
                item.fill(prod);
                this.page.ctrls.listProducts.append(item);
            }
            gs.StateGS.CatchLinks();
            this._skip += StatePaged_1.StatePaged.TakeProductsCount;
            this.page.ctrls.cmpPagination.show();
            if (this._skip >= this._productIds.length)
                this.page.ctrls.cmpPagination.hide();
        });
    }
    _addListPlaceholders() {
        for (let i = 0; i < StatePaged_1.StatePaged.TakeProductsCount; i++) {
            let item = new CmpProductTile_1.CmpProductTile();
            item.addClass(ClassesTags_1.ClassesTags.Loading);
            this.page.ctrls.listProducts.append(item);
        }
    }
    _failedLoadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            //TODO
        });
    }
}
exports.StateSearch = StateSearch;
StateSearch.StateName = "search";
//# sourceMappingURL=StateSearch.js.map